import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${BACKEND}/api/auth/forgot-password`, { email: email.trim().toLowerCase() });
      setSubmitted(true);
    } catch (err: any) {
      const status = err.response?.status;
      if (status === 429) {
        toast.error('Çok fazla istek. Lütfen birkaç dakika sonra tekrar deneyin.');
      } else {
        toast.error(err.response?.data?.detail || 'Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#6b0f1a] to-[#8a1422] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-[#6b0f1a]">Şifremi Unuttum</h1>
            <p className="text-gray-600 mt-2 text-sm">
              Hesabınıza bağlı e-posta adresinizi girin, size şifre sıfırlama bağlantısı gönderelim.
            </p>
          </div>

          {submitted ? (
            <div className="text-center space-y-4" data-testid="forgot-password-sent">
              <div className="w-16 h-16 mx-auto bg-emerald-100 rounded-full flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-emerald-600"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              </div>
              <h2 className="text-xl font-bold text-gray-800">Kontrol Edin 📬</h2>
              <p className="text-sm text-gray-600">
                <strong>{email}</strong> adresine bir şifre sıfırlama bağlantısı gönderdik.<br />
                Gelen kutunuzu (ve spam klasörünü) kontrol edin.
              </p>
              <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 text-xs text-amber-800">
                ⏱ Bağlantı 15 dakika içinde geçerliliğini yitirecektir.
              </div>
              <p className="text-xs text-gray-500 mt-4">
                E-posta 2-3 dakika içinde gelmezse spam'e düşmüş olabilir.
              </p>
              <Link to="/login" className="block text-sm text-[#6b0f1a] hover:underline mt-4">
                ← Giriş sayfasına dön
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">E-posta</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="ornek@stüdyo.com"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#6b0f1a] focus:border-transparent"
                  required
                  autoFocus
                  data-testid="forgot-password-email"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#6b0f1a] text-white py-3 rounded-lg font-semibold hover:bg-[#8a1422] disabled:opacity-50 transition-colors"
                data-testid="forgot-password-submit"
              >
                {loading ? 'Gönderiliyor...' : 'Sıfırlama Bağlantısı Gönder'}
              </button>
              <div className="bg-blue-50 border border-blue-100 rounded-lg p-3 text-xs text-blue-800">
                <strong>💡 E-posta adresiniz kayıtlı değilse:</strong>
                <ul className="mt-1 ml-4 list-disc space-y-0.5">
                  <li>Personelseniz: Şube yöneticinizden e-posta adresinizi sisteme eklemesini isteyin.</li>
                  <li>Genel Müdür / Şube Müdürüyseniz: E-postanız zorunludur — Genel Müdürlük ile iletişime geçin.</li>
                </ul>
              </div>
              <div className="text-center pt-2">
                <Link to="/login" className="text-sm text-gray-600 hover:text-[#6b0f1a]" data-testid="forgot-password-back">
                  ← Giriş sayfasına dön
                </Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
